"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var styles_1 = require("./styles");

var FullTableSearchNoResults =
/** @class */
function (_super) {
  __extends(FullTableSearchNoResults, _super);

  function FullTableSearchNoResults() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FullTableSearchNoResults.prototype.render = function () {
    var search = this.props.search;
    return search ? React.createElement("div", __assign({}, font_1.bold, styles_1.noResultsFoundStyle), search.noResults) : null;
  };

  return FullTableSearchNoResults;
}(React.Component);

exports.FullTableSearchNoResults = FullTableSearchNoResults;